import { render, staticRenderFns } from "./travelOverview.vue?vue&type=template&id=074483d0&scoped=true&lang=html&"
import script from "./travelOverview.vue?vue&type=script&lang=js&"
export * from "./travelOverview.vue?vue&type=script&lang=js&"
import style0 from "./travelOverview.vue?vue&type=style&index=0&id=074483d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074483d0",
  null
  
)

export default component.exports